import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-view" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "status-section" }
const _hoisted_4 = { class: "actions-section" }

import { useRouter } from 'vue-router';
import { useSpotifyAuth } from '@/composables/useSpotifyAuth';
import { useGameState } from '@/composables/useGameState';
import SpotifyConnectButton from '@/components/Spotify/SpotifyConnectButton.vue';
import SpotifyStatusBadge from '@/components/Spotify/SpotifyStatusBadge.vue';
import PrimaryButton from '@/components/UI/PrimaryButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter();
const { isAuthenticated, isPremium, logout } = useSpotifyAuth();
const { setMode } = useGameState();

function continueWithoutSpotify() {
  setMode('preview');
  router.push('/game');
}

function startGame() {
  // Modus basierend auf Auth-Status setzen
  if (isAuthenticated.value && isPremium.value) {
    setMode('premium');
  } else {
    setMode('preview');
  }
  router.push('/game');
}

function handleLogout() {
  logout();
  setMode('none');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "hero-section" }, [
        _createElementVNode("h1", { class: "app-title" }, "🎵 SoundBattle"),
        _createElementVNode("p", { class: "app-subtitle" }, "Das ultimative Musik-Quiz-Spiel")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SpotifyStatusBadge)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_unref(isAuthenticated))
          ? (_openBlock(), _createBlock(SpotifyConnectButton, {
              key: 0,
              size: "lg",
              "full-width": ""
            }))
          : _createCommentVNode("", true),
        (!_unref(isAuthenticated))
          ? (_openBlock(), _createBlock(PrimaryButton, {
              key: 1,
              variant: "ghost",
              size: "lg",
              "full-width": "",
              onClick: continueWithoutSpotify
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Ohne Spotify fortfahren (nur 30 Sek. Vorschau) ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(PrimaryButton, {
          size: "lg",
          "full-width": "",
          onClick: startGame
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" Spiel starten ", -1)
          ]))]),
          _: 1
        }),
        (_unref(isAuthenticated))
          ? (_openBlock(), _createBlock(PrimaryButton, {
              key: 2,
              variant: "secondary",
              size: "md",
              "full-width": "",
              onClick: handleLogout
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Von Spotify trennen ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "info-box" }, [
        _createElementVNode("h3", null, "Wie funktioniert SoundBattle?"),
        _createElementVNode("ol", null, [
          _createElementVNode("li", null, "Scanne den QR-Code auf deiner Spielkarte"),
          _createElementVNode("li", null, "Drücke den Play-Button"),
          _createElementVNode("li", null, "Drehe dein Handy mit dem Display nach unten"),
          _createElementVNode("li", null, "Der Song startet automatisch!")
        ]),
        _createElementVNode("p", { class: "info-note" }, " Mit Spotify Premium kannst du komplette Songs hören. Ohne Premium gibt's 30-Sekunden-Vorschauen. ")
      ], -1))
    ])
  ]))
}
}

})